/**
 * News index page entry — tag filters (TomSelect) + Flatpickr + load more.
 */

import { initTagFilters } from "../widgets/tag-filters";
import { initDatePickers, initDatePickerIcons, initLoadMore } from "./load-more";

document.addEventListener("DOMContentLoaded", () => {
  initTagFilters();
  initDatePickers();
  initDatePickerIcons();
  initLoadMore();
});
